import "./FamilyMyTracker.scss";
import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import RegularIconText from "./../../Atoms/RegularIconText/RegularIconText";
import MY_TRACKER_IMG from "../../../assets/img/MY_TRACKER_IMG.jpg";
import MY_TRACKER_ICON_1 from "../../../assets/img/MY_TRACKER_ICON_1.svg";
import MY_TRACKER_ICON_2 from "../../../assets/img/MY_TRACKER_ICON_2.svg";
import MY_TRACKER_ICON_3 from "../../../assets/img/MY_TRACKER_ICON_3.svg";
import MY_TRACKER_ICON_4 from "../../../assets/img/MY_TRACKER_ICON_4.svg";
import MY_TRACKER_ICON_5 from "../../../assets/img/MY_TRACKER_ICON_5.svg";
import MY_TRACKER_ICON_6 from "../../../assets/img/MY_TRACKER_ICON_6.svg";
import GPS_PORTATIL from "../../../assets/img/GPS_PORTATIL.png";
import FormShell from "../../Organisms/FormShell/FormShell";
import DynamicFormik from "../../Organisms/DynamicFormik/DynamicFormik";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const FamilyMyTracker = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2
				withTitle
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
				appearSecondNavbar={dropdownHeader}
			/>

			<div className="top-space-section">
				<CenteredHeader
					boldText={content[language].tracker_bold_title}
					yellowText={content[language].tracker_red_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{ img: MY_TRACKER_IMG, alt: "Telefono Con Tracker App" }}
					boldText={content[language].tracker_bold_text}
					paragraphs={content[language].tracker_text}
				/>
			</div>

			<div className="all-width light-blue-bg top-space-section bottom-space-section padding ">
				<h5 className="center-text t5 no-space c-yellow yellow-line both-sides">
					{content[language].beneficios_red_title}
				</h5>
				<div className="max-width familyMyTracker-regular-icon-container top-space-section">
					<RegularIconText
						icon={MY_TRACKER_ICON_1}
						text={content[language].beneficio_1}
						width="100%"
					/>
					<RegularIconText
						icon={MY_TRACKER_ICON_2}
						text={content[language].beneficio_2}
						width="100%"
					/>
					<RegularIconText
						icon={MY_TRACKER_ICON_3}
						text={content[language].beneficio_3}
						width="100%"
					/>
					<RegularIconText
						icon={MY_TRACKER_ICON_4}
						text={content[language].beneficio_4}
						width="100%"
					/>
					<RegularIconText
						icon={MY_TRACKER_ICON_5}
						text={content[language].beneficio_5}
						width="100%"
					/>
					<RegularIconText
						icon={MY_TRACKER_ICON_6}
						text={content[language].beneficio_6}
						width="100%"
					/>
				</div>
			</div>

			<IndustryBannerBgSection route="my-tracker">
				<IndustryImageTextSection
					familyCase
					leftBoldText={content[language].beneficio_7_bold_title}
					lefText={content[language].beneficio_7_text}
					rightBoldText={content[language].beneficio_8_bold_title}
					rightext={content[language].beneficio_8_text}
				/>
			</IndustryBannerBgSection>

			<div className="top-space-section">
				<IndustryImageTextSection
					switchOrder
					yellowText={content[language].caracteristicas_red_title}
					boldText={content[language].caracteristicas_bold_text}
					checkText={content[language].caracteristicas_list}
					image={{
						img: GPS_PORTATIL,
						alt: "Tablet con Mapa en Pantalla",
					}}
				/>
			</div>

			<div className="top-space-section">
				<FormShell contact title={content[language].form_title}>
					<DynamicFormik
						buttonContent={content[language].form_button_content}
						field_1={content[language].form_fields[0]}
						field_2={content[language].form_fields[1]}
						field_3={content[language].form_fields[2]}
						field_4={content[language].form_fields[3]}
						field_5={content[language].form_fields[4]}
						field_6={content[language].form_fields[5]}
						field_7={content[language].form_fields[6]}
					/>
				</FormShell>
			</div>
		</>
	);
};

export default FamilyMyTracker;
